module.exports = __webpack_public_path__ + "static/wisr-welcome-light-eab3c68f19c6c45c2a2b7b3c0cb4be84.png";